import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSell = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 29,
	height: 29,
	viewBox: "0 0 29 29",
	fill: "none",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2.48629 3.70953C2.64658 3.25364 3.14609 3.014 3.60198 3.17428L3.95361 3.29791C4.6729 3.55076 5.2838 3.76552 5.76457 4.00142C6.27864 4.25365 6.71946 4.56438 7.05101 5.04955C7.37998 5.53097 7.5158 6.05914 7.57849 6.63825C7.60655 6.89748 7.62135 7.18441 7.62916 7.4998H20.0404C22.0062 7.4998 23.7758 7.4998 24.2937 8.17306C24.8116 8.84632 24.6091 9.86077 24.2042 11.8897L23.6211 14.7185C23.2535 16.5022 23.0697 17.3941 22.426 17.9186C21.7823 18.4431 20.8717 18.4431 19.0505 18.4431H12.8638C9.6101 18.4431 7.98323 18.4431 6.97243 17.377C5.96163 16.3109 5.88786 15.1783 5.88786 11.7465L5.88785 8.71117C5.88785 7.8479 5.88666 7.27014 5.83865 6.82657C5.79277 6.40266 5.71145 6.191 5.60614 6.03691C5.50341 5.88657 5.34746 5.74606 4.99369 5.57248C4.61704 5.38767 4.10517 5.2062 3.32629 4.93236L3.02154 4.82522C2.56565 4.66494 2.32601 4.16543 2.48629 3.70953Z",
			fill: "#808080"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.80477 21.4998C9.77127 21.4998 10.5548 22.2833 10.5548 23.2498C10.5548 24.2163 9.77127 24.9998 8.80477 24.9998C7.83827 24.9998 7.05477 24.2163 7.05477 23.2498C7.05477 22.2833 7.83827 21.4998 8.80477 21.4998Z",
			fill: "#808080"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.3048 21.4999C20.2713 21.4999 21.0548 22.2834 21.0548 23.2499C21.0548 24.2164 20.2713 24.9999 19.3048 24.9999C18.3383 24.9999 17.5548 24.2164 17.5548 23.2499C17.5548 22.2834 18.3383 21.4999 19.3048 21.4999Z",
			fill: "#808080"
		})
	]
});
const ForwardRef = forwardRef(SvgSell);
export default ForwardRef;
